import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AsignarProgramasFormComponent } from '../form/asignar-programas-form.component';
import { ProgramService } from '../../../core/services/api/program.service';
import { AsignarProgramasLinkComponent } from '../link/asignar-programas-link.component';
import { Swal2 } from 'src/app/core/utils/swal2.util';
import { FormControl } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { ProgramLegacy } from 'src/app/core/contracts/models/program.model';
import {finalize} from 'rxjs/operators';

@Component({
    selector: 'app-asignar-programas-list',
    templateUrl: './asignar-programas-list.component.html',
    styleUrls: ['./asignar-programas-list.component.scss']
})
export class AsignarProgramasListComponent implements OnInit {

    @Input() id: number;
    /** Se emite cada vez que se recargan los programas (el formulario del medio habilita "Asignar contactos") */
    @Output() rowsChange = new EventEmitter<ProgramLegacy[]>();
    rows: ProgramLegacy[] = [];
    loading = true;
    messages = {emptyMessage: 'No hay información para mostrar.'};

    searchForm = new FormControl<string>(null);
    keys = ['nombre', 'descripcion'];

    addPermission = this.auth.isPermit('medio.programa.add')
    editPermission = this.auth.isPermit('medio.programa.edit')
    deletePermission = this.auth.isPermit('medio.programa.delete')

    constructor(
        public dialog: MatDialog,
        private programService: ProgramService,
        private auth: AuthService,
        private swal: Swal2
    ) {
    }

    ngOnInit(): void {
        this.getAll();
        // console.log(this.id);
        
    }

    getAll() {
        this.loading = true;
        this.programService.getAll(this.id).pipe(finalize(() => this.loading = false)).subscribe(result => {
            this.rows = result;
            this.rowsChange.emit(this.rows);
        });
    }

    add() {
        this.openDialog();
    }

    edit(row: any) {
        this.openDialog(row);
    }

    getRowHeight(row: ProgramLegacy) {
        return Math.max(50, Math.floor(row.programa_plataformas.length * 20) + 50);
    } 

    openDialog(row?: any) {
        const dialogRef = this.dialog.open(AsignarProgramasFormComponent, {
            data: { row, id: this.id },
            width: '950px',
        });

        dialogRef.afterClosed().subscribe(result => {
            // Al editar, las plataformas se guardan al instante aunque luego se pulse Cancelar:
            // se recarga igual para reflejarlas (y actualizar la pestaña "Asignar contactos")
            if (result || row) {
                this.getAll();
            }
        });
    }

    delete(id: number) {
        this.swal.deleteItem().then(val => {
            if (val) {
                this.programService.delete(id).subscribe((response: any) => {
                    this.getAll();
                    this.swal.showTitleAlert('Eliminado', response.message, 'success');
                }, error => {
                    this.swal.showErrorAlert(error.error.message);
                });
            }
        });
    }

    link(row) {
        const dialogRef = this.dialog.open(AsignarProgramasLinkComponent, {
            data: row,
            width: '850px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getAll();
            }
        });
    }
}